const axios = require('axios');
const moment = require('moment');
// const loginData = require('./config.json')['pos-server'];
const { deepCopy } = require('../assets/functions/deepCopy');

const loginData = require('./config.json')[process.env.VUE_APP_CONFIG];

const apiServer = axios.create({
  baseURL: loginData.url,
  headers: {
    'Content-Type': 'text/plain',
    token: '',
    appVersion: '20',
  },
  timeout: 30000,
});

const additionalIndex = [1, 2, 3, 4, 5];

const buildTableStatusInfo = (data, defaultStatus = '3') => {
  if (!data.tableId) return {};

  const currentInfo = data.tableStatusInfo || {};
  return {
    ...currentInfo,
    tableId: data.tableId,
    tableStatus: currentInfo.tableStatus || data.tableStatus || defaultStatus,
    transactionId: data.transactionId || currentInfo.transactionId || '',
    clientTransactionId: data.clientTransactionId || currentInfo.clientTransactionId || '',
    transactionTypeId: data.transactionTypeId || currentInfo.transactionTypeId || '',
    guests: data.guests || currentInfo.guests || '1',
    posMemberReserveId: data.posMemberReserveId || currentInfo.posMemberReserveId || '',
    memberId: data.memberId || currentInfo.memberId || '',
    contactPersonName: data.contactPersonName || currentInfo.contactPersonName || '',
    bookingDate: data.bookingDate || currentInfo.bookingDate || '',
    createDate: currentInfo.createDate || data.createDate || moment().format('YYYY-M-D HH:mm:ss'),
  };
};

module.exports = exports = {
  TransactionContent: () => ({
    transactionTypeId: '', // required
    transactionTypeName: '', // required
    oneTimeKey: '', // if pay by linepay
    storeId: '', // required
    posId: 'KIOSK-000-002', // required
    userId: 'admin', // required
    memberId: '',
    redeemRewardPoints: '0',
    invoiceId: '',
    invoiceRndCode: '',
    customerId: '',
    tableId: '',
    tableStatusInfo: {},
    checkCode: '',
    discount: '0',
    rebate: '0',
    serviceCharge: '0',
    guests: '1',
    total: '0', // required
    discountAmount: '0',
    receiveTotal: '0',
    overChargeAmount: '0',
    transactionStatusId: '',
    paymentType: '',
    log: [], // Trans.Order
    startDate: '',
    endDate: '',
    statisticalType: '',
    relativeTransactionId: '',
    memo: '',
    isProcessInvoice: '0',
    transactionPaymentList: [],
    isInvoice: 'Y',
    invoiceDate: '',
    cashDeviceId: '',
    invoiceDeviceId: '',
    takeOutInfo: {
      customer_name: 'KIOSK', // required
      customer_phone_number: 'KIOSK12345', // required
      customer_address: 'KIOSK12345', // required
      customer_remark: '',
      customer_email: '',
      waitTime: '',
      contactTakeOutTime: '',
      isProcessDelivery: 'N', // 確認叫件
      deliveryVender: '', // 快遞業者
      deliveryPrice: 0, // 扣除折扣後消費者實際要付的運費
      originalDeliveryPrice: 0, // 運費原價
      deliveryOrderDetail: {}, // 查詢報價後之回傳資料
    },
    createDate: '',
    renewDate: '',
    bizDate: '',
    buyerTaxId: '',
    BUYER_BAN: '',
    BUYER_NAME: '顧客',
    DONATE_MARK: '0',
    NPOBAN: '',
    CARRIER_TYPE: '',
    CARRIER_ID1: '',
    CARRIER_ID2: '',
    PRINT_MARK: 'Y',
    SALE_AMT: '',
    FREE_TAX_SALE_AMT: '0',
    ZERO_TAX_SALE_AMT: '0',
    TAX_TYPE: '1',
    TAX_RATE: '0.05',
    TAX_AMT: '0',
    TOTAL_AMT: '0',
    STN_NO: '',
  }),
  Order: (content) => ({
    product: content,
    isGroup: 'N',
    groupNo: '',
    productGroupId: '',
    productGroupName: '',
    productGroupTypeId: '',
    productGroupTypeName: '',
    productGroupPrice: '',
    discount: '0',
    discountAmount: '0',
    rebate: '0',
    subTotal: (() => {
      const additionalTotal = additionalIndex.reduce((subAccu, subCurr) => {
        let _price = 0;
        const additionalObj = content[`additionalOfProduct${subCurr}`];
        if (additionalObj && additionalObj.products) {
          additionalObj.products.forEach((additionalProduct) => {
            if (additionalProduct.productPrice) {
              _price += parseInt(additionalProduct.productPrice, 10);
            }
          });
        }
        return subAccu + _price;
      }, 0);
      return parseInt(content.productPrice, 10) + additionalTotal;
    })(),
    rewardPointsName: '',
    redeemRewardPoints: '',
    serviceCharge: content.serviceCharge,
    isEntertain: 'N',
    productCount: '1',
    presentPrice: '',
    memo: '',
  }),
  GroupOrder: (content, groupInfo) => {
    const order = {
      product: content,
      isGroup: 'Y',
      groupNo: '',
      productGroupId: '',
      productGroupName: '',
      productGroupTypeId: '',
      productGroupTypeName: '',
      productGroupPrice: '',
      discount: '0',
      discountAmount: '0',
      rebate: '0',
      subTotal: '',
      rewardPointsName: '',
      redeemRewardPoints: '',
      serviceCharge: content.serviceCharge,
      isEntertain: 'N',
      productCount: '1',
      presentPrice: '',
      memo: '',
    };
    return { ...order, ...groupInfo };
  },
  getProfile: (contractNo) => {
    apiServer.defaults.headers.token = ''; // reset token
    apiServer.defaults.headers.appVersion = '20';
    const postData = {
      request: '',
      requestDataString: '',
      apiToken: '',
      apiTokenObject: '',
    };
    return new Promise((resolve, reject) => {
      if (loginData && contractNo) {
        loginData.contractNo = contractNo;
        loginData.pageName = 'onlineOrder';
        postData.request = 'clientUserLogin';
        postData.requestDataString = Buffer.from(JSON.stringify(loginData))
          .toString('base64');
        apiServer.post('requestDataService.ashx', postData)
          .then((res) => {
            if (res.data && res.data.rs === 'OK') {
              const buff = Buffer.from(res.data.data, 'base64');
              const profile = JSON.parse(buff.toString());
              profile.invalidDate = moment()
                .add(1, 'days')
                .format();
              resolve(profile);
            }
          })
          .catch(() => {
            reject();
          });
      } else {
        reject(new Error('login data had not found.'));
      }
    });
  },
  getSubStoreNo: (token, mainContractNo) => {
    const postData = {
      request: '',
      requestDataString: '',
    };
    return new Promise((resolve, reject) => {
      if (mainContractNo) {
        postData.request = 'subStoreReadByContractNo';
        postData.requestDataString = Buffer.from(JSON.stringify({ contractNo: mainContractNo })).toString('base64');
        apiServer.defaults.headers.token = token;
        apiServer.post('requestDataService.ashx', postData)
          .then((res) => {
            if (res.data && res.data.rs === 'OK') {
              const buff = Buffer.from(res.data.data, 'base64');
              const info = JSON.parse(buff.toString());
              resolve(info);
            }
          })
          .catch(() => {
            reject();
          });
      } else {
        reject(new Error('login data had not found.'));
      }
    });
  },
  itemsToLog: (content) => {
    const log = [];
    // order details
    content.forEach((item, index) => {
      const logItem = { ...item };
      let _order = null;

      // 套餐
      if (logItem.isGroup) {
        const {
          productGroupId,
          productGroupName,
          productGroupTypeId,
          productGroupTypeName,
        } = logItem.groupMainItem;

        const _groupInfo = {
          productGroupId,
          productGroupName,
          productGroupTypeId,
          productGroupTypeName,
          groupNo: index + 1,
        };

        const _groupPrice = (_idx) => {
          if (_idx === 0) {
            return logItem.groupAmounts.reduce((accu, curr) => accu + curr, 0)
              .toString();
          }
          return '';
        };

        // 套餐選擇項目
        logItem.groupSelectedItem.forEach((sItem, sIdx) => {
          // 群組號碼附加項目index： 1-1, 1-2...
          _order = new exports.GroupOrder(sItem, {
            ..._groupInfo,
            // 加選項目總金額寫在第一選項中，其餘金額均為空字串
            groupNo: `${_groupInfo.groupNo}-${sIdx + 1}`,
            productGroupPrice: _groupPrice(sIdx),
            subTotal: _groupPrice(sIdx),
          });
          log.push(_order);
        });
        return;
      }
      // 單點
      _order = new exports.Order(item);
      log.push(_order);
    });
    return log;
  },
  sortLog: (log) => {
    const _logResult = [];
    const _logItems = deepCopy(log);
    const _logAlacarte = {};
    _logItems.forEach((_item) => {
      if (_item.isGroup === 'Y') {
        _logResult.push(_item);
      } else {
        const product = deepCopy(_item.product);
        let keyName = product.productName;
        const additionArr = [];
        for (let i = 1; i <= 5; i += 1) {
          const addition = product[`additionalOfProduct${i}`];
          if (addition !== null) { // 一定是 object，可以放心遞迴或做物件處理
            additionArr.push(addition);
          }
        }
        additionArr.sort((a, b) => a.productTypeName.localeCompare(b.productTypeName));
        additionArr.forEach((additionItem) => {
          additionItem.products.sort((a, b) => a.productName.localeCompare(b.productName));
        });
        additionArr.forEach((additionItem) => {
          keyName += additionItem.productTypeName;
          additionItem.products.forEach((product) => {
            keyName += product.productName;
          });
        });
        if (!_logAlacarte[keyName]) {
          _logAlacarte[keyName] = { product: {}, count: 1 };
          _logAlacarte[keyName].product = _item;
        } else {
          _logAlacarte[keyName].count += 1;
        }
      }
    });
    // eslint-disable-next-line guard-for-in, prefer-const, no-restricted-syntax
    for (let key in _logAlacarte) {
      const data = deepCopy(_logAlacarte[key].product);
      data.productCount = _logAlacarte[key].count.toString();
      data.subTotal = (_logAlacarte[key].product.subTotal * _logAlacarte[key].count).toString();
      _logResult.push(data);
    }
    _logResult.reverse();
    return _logResult;
  },
  doTransaction: (token, _data) => new Promise((resolve, reject) => {
    const data = deepCopy(_data);
    const tContent = new exports.TransactionContent();
    tContent.transactionTypeId = data.diningIn.transactionTypeId; // 內用外帶外送id
    tContent.transactionTypeName = data.diningIn.transactionTypeName; // 內用外帶外送
    if (data.guests) tContent.guests = data.guests; // 用餐人數
    if (data.tableId) tContent.tableId = data.tableId; // 內用桌號
    tContent.tableStatusInfo = buildTableStatusInfo({
      ...data,
      transactionTypeId: tContent.transactionTypeId,
      guests: tContent.guests,
    });
    tContent.serviceCharge = data.totalServiceFee; // 服務費
    tContent.receiveTotal = data.totalAmount;
    tContent.total = data.totalAmount + data.totalServiceFee;

    if (data.paymentType.storePaymentType) {
      data.paymentType.storePaymentType.paymentAmount = tContent.total.toString();
      tContent.transactionPaymentList.push(data.paymentType.storePaymentType);
      tContent.isSendToOnlineOrder = data.paymentType.storePaymentType.isSendToOnlineOrder || 'N';
      // tContent.isNeedOnlineOrderNoticed = data.paymentType.storePaymentType.isNeedOnlineOrderNoticed || 'Y';
      tContent.isNeedOnlineOrderNoticed = 'N';
    }
    // 有外送電話
    if (data.takeOutInfo.customer_phone_number) {
      tContent.takeOutInfo = data.takeOutInfo;
    }

    tContent.TOTAL_AMT = tContent.total;
    tContent.SALE_AMT = tContent.TOTAL_AMT;
    tContent.TAX_AMT = 0;

    if (data.invoiceBuyerVat) {
      tContent.buyerTaxId = data.invoiceBuyerVat; // 買受人統一編號
      tContent.BUYER_BAN = data.invoiceBuyerVat; // 買受人統一編號
      // 有統編才要計算稅
      tContent.SALE_AMT = Math.ceil(tContent.TOTAL_AMT * (1 - tContent.TAX_RATE)).toString();
      tContent.TAX_AMT = (tContent.TOTAL_AMT - tContent.SALE_AMT).toString();
    }
    tContent.TOTAL_AMT = tContent.TOTAL_AMT.toString();

    // 載具：手機條碼
    if (data.invoiceCarrierCode && data.invoiceCarrierCode.length === 8) {
      tContent.CARRIER_TYPE = '3J0002';
      tContent.CARRIER_ID1 = data.invoiceCarrierCode;
      tContent.CARRIER_ID2 = data.invoiceCarrierCode;
      tContent.PRINT_MARK = 'N';
    }
    // 載具：自然人憑證條碼
    if (data.invoiceCarrierCode && data.invoiceCarrierCode.length === 16) {
      tContent.CARRIER_TYPE = 'CQ0001';
      tContent.CARRIER_ID1 = data.invoiceCarrierCode;
      tContent.CARRIER_ID2 = data.invoiceCarrierCode;
      tContent.PRINT_MARK = 'N';
    }

    // 愛心碼
    if (data.invoiceDonateCode) {
      tContent.DONATE_MARK = '1';
      tContent.NPOBAN = data.invoiceDonateCode;
      tContent.PRINT_MARK = 'N';
    }

    // order details
    tContent.log = exports.sortLog(exports.itemsToLog(data.items));
    // 如果有加點
    if (data.log?.length > 0) {
      const tempLog = deepCopy(data.log);
      tContent.log = tempLog.concat(tContent.log);
    }

    const { clientTransactionId, transactionId } = data.QrcodeData;

    let action = '';
    switch (data.paymentType.name) {
      case 'creditCard':
      case 'eStoredValue':
        action = 'koTransactionSubmit'; // API 指令  其他付款方式，僅處理訂單
        tContent.transactionStatusId = '5';
        break;
      case 'linepay':
        action = 'koLINEPayRequestPay'; // API 指令 Linepay付款讀取使用者條碼程序
        // tContent.oneTimeKey = data.paymentCode;
        tContent.transactionStatusId = '2';
        tContent.isProcessInvoice = '0'; // 不取發票
        tContent.isNeedOnlineOrderNoticed = 'Y';
        break;
      case 'jkopay':
        action = 'koJKOPayRequestCapture'; // API 指令 街口支付讀取使用者條碼程序
        tContent.oneTimeKey = data.paymentCode;
        tContent.transactionStatusId = '5';
        tContent.isNeedOnlineOrderNoticed = 'Y';
        break;
      case 'counter':
        action = 'koTransactionSubmit'; // API 指令  其他付款方式，僅處理訂單
        // if (transactionId.length > 0 && clientTransactionId.length > 0) {
        //   tContent.clientTransactionId = clientTransactionId;
        //   tContent.transactionId = transactionId;
        //   // action = 'submitTransaction';
        //   apiServer.defaults.headers.appVersion = '8';
        // }
        tContent.transactionStatusId = (tContent.isSendToOnlineOrder === 'Y') ? '12' : '2'; // 未結帳
        tContent.isNeedOnlineOrderNoticed = 'N';
        tContent.isProcessInvoice = '0'; // 不取發票
        break;
      case 'prepaid':
        action = 'koTransactionSubmit'; // API 指令  其他付款方式，僅處理訂單
        tContent.transactionStatusId = '15';
        tContent.isProcessInvoice = '0'; // 不取發票
        tContent.isNeedOnlineOrderNoticed = 'N';
        // tContent.isSendToOnlineOrder = 'Y'; // 出現在線上訂單列表
        break;
      case 'tp-creditcard':
      case 'tp-linepay':
        tContent.transactionStatusId = '12';
        tContent.isProcessInvoice = '0'; // 不取發票
        tContent.isNeedOnlineOrderNoticed = 'Y';
        break;
      default:
    }

    if (token) {
      // apiServer.defaults.headers.appVersion = '2';
      apiServer.defaults.headers.token = token;
      const postData = {
        // pageToken: token, // token 置於header或此欄位都可
        captcha: '', // 驗證碼(已取消)
        action, // API 指令
        itemCount: data.items.length, // 商品總數 (Line Pay 顯示)
        itemName: `${data.storeName}商品`, // 商品名稱 (Line Pay 顯示)
        requestDataString: tContent, // 訂單
      };
      // if ((transactionId.length > 0 && clientTransactionId.length > 0) || data?.prime?.type) {
      if ((transactionId.length > 0 && clientTransactionId.length > 0)) {
        // if (transactionId.length > 0 && clientTransactionId.length > 0) {
        tContent.clientTransactionId = clientTransactionId;
        tContent.transactionId = transactionId;
        // }
        tContent.storeId = data.storeId;
        tContent.tableStatusInfo = buildTableStatusInfo(tContent);
        const postData = {
          request: 'koUpdateTransaction',
          requestDataString: Buffer.from(JSON.stringify(tContent)).toString('base64'),
          apiToken: '',
          apiTokenObject: '',
        };
        // apiServer.defaults.headers.appVersion = '7';
        apiServer.post('requestDataService.ashx', postData)
          .then((res) => {
            if (res.data && res.data.rs === 'OK') {
              res.tContent = tContent;
              resolve(res);
            } else {
              reject();
            }
          })
          .catch((err) => {
            console.log('pos transaction error', err);
            reject(new Error('pos transaction error'));
          });
      } else if (data?.prime?.type) {
        tContent.storeId = data.storeId;
        tContent.tableStatusInfo = buildTableStatusInfo(tContent);
        const res = {};
        res.tContent = tContent;
        resolve(res);
      } else {
        apiServer.post('frontService.ashx', postData)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            console.log('pos transaction error', err);
            reject(new Error('pos transaction error'));
          });
      }
    }
  }),
  updateTransaction: (token, data) => new Promise((resolve, reject) => {
    if (data.paymentType.storePaymentType) {
      data.paymentType.storePaymentType.paymentAmount = data.total.toString();
      data.transactionPaymentList.push(data.paymentType.storePaymentType);
    }

    const { clientTransactionId, transactionId } = data;

    let action = '';
    switch (data.paymentType.name) {
      case 'creditCard':
      case 'eStoredValue':
        action = 'koTransactionSubmit'; // API 指令  其他付款方式，僅處理訂單
        data.transactionStatusId = '5';
        break;
      case 'linepay':
        action = 'koLINEPayRequestPay'; // API 指令 Linepay付款讀取使用者條碼程序
        data.transactionStatusId = '2';
        data.isProcessInvoice = '0'; // 不取發票
        data.isNeedOnlineOrderNoticed = 'Y';
        break;
      case 'jkopay':
        action = 'koJKOPayRequestCapture'; // API 指令 街口支付讀取使用者條碼程序
        data.oneTimeKey = data.paymentCode;
        data.transactionStatusId = '5';
        data.isNeedOnlineOrderNoticed = 'Y';
        break;
      case 'counter':
        action = 'koTransactionSubmit'; // API 指令  其他付款方式，僅處理訂單
        data.transactionStatusId = (data.isSendToOnlineOrder === 'Y') ? '12' : '2'; // 未結帳
        data.isNeedOnlineOrderNoticed = 'N';
        data.isProcessInvoice = '0'; // 不取發票
        break;
      case 'prepaid':
        action = 'koTransactionSubmit'; // API 指令  其他付款方式，僅處理訂單
        data.transactionStatusId = '15';
        data.isNeedOnlineOrderNoticed = 'N';
        data.isProcessInvoice = '0'; // 不取發票
        break;
      case 'tp-creditcard':
      case 'tp-linepay':
        data.transactionStatusId = '12';
        data.isProcessInvoice = '0'; // 不取發票
        data.isNeedOnlineOrderNoticed = 'Y';
        break;
      default:
    }

    if (token) {
      apiServer.defaults.headers.token = token;
      const postData = {
        captcha: '', // 驗證碼(已取消)
        action, // API 指令
        itemCount: data.log.length, // 商品總數 (Line Pay 顯示)
        itemName: `${data.storeName}商品`, // 商品名稱 (Line Pay 顯示)
        requestDataString: data, // 訂單
      };
      if ((transactionId.length > 0 && clientTransactionId.length > 0) || data?.prime?.type) {
        if (transactionId.length > 0 && clientTransactionId.length > 0) {
          data.clientTransactionId = clientTransactionId;
          data.transactionId = transactionId;
        }
        data.tableStatusInfo = buildTableStatusInfo(data);
        const postData = {
          request: 'koUpdateTransaction',
          requestDataString: Buffer.from(JSON.stringify(data)).toString('base64'),
          apiToken: '',
          apiTokenObject: '',
        };
        apiServer.post('requestDataService.ashx', postData)
          .then((res) => {
            if (res.data && res.data.rs === 'OK') {
              res.tContent = data;
              resolve(res);
            } else {
              reject();
            }
          })
          .catch((err) => {
            console.log('pos transaction error', err);
            reject(new Error('pos transaction error'));
          });
      } else {
        apiServer.post('frontService.ashx', postData)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            console.log('pos transaction error', err);
            reject(new Error('pos transaction error'));
          });
      }
    }
  }),
  getDeliveryQuotation: (token, data) => {
    const postData = {
      request: '',
      requestDataString: '',
      apiToken: '',
      apiTokenObject: '',
    };
    return new Promise((resolve, reject) => {
      if (token) {
        postData.request = 'posRequestGBQuotation';
        postData.requestDataString = Buffer.from(JSON.stringify(data))
          .toString('base64');
        apiServer.defaults.headers.token = token;
        apiServer.defaults.headers.appVersion = '10';
        apiServer.post('requestDataService.ashx', postData)
          .then((res) => {
            if (res.data && res.data.rs === 'OK') {
              const buff = Buffer.from(res.data.data, 'base64');
              const quotation = JSON.parse(buff.toString());
              // console.log('quotation', quotation);
              resolve(quotation);
            } else {
              reject(res.data);
            }
          })
          .catch((error) => {
            console.log('error', error);
            reject();
          });
      } else {
        reject(new Error('login data had not found.'));
      }
    });
  },
  getTransactionByIdPostInfo: (token, Id, storeId, hasQrcode) => {
    let transactionStatusId = '';
    let appVersion = '';
    if (hasQrcode) {
      // transactionStatusId = '12';
      transactionStatusId = '';
      appVersion = '6';
    } else {
      transactionStatusId = '5,12,15';
      appVersion = '8';
    }
    const requestData = {
      transactionId: '',
      clientTransactionId: Id,
      transactionTypeId: '',
      storeId,
      transactionStatusId,
    };
    const postData = {
      request: 'readTransaction',
      requestDataString: Buffer.from(JSON.stringify(requestData)).toString('base64'),
      apiToken: '',
      apiTokenObject: '',
    };
    apiServer.defaults.headers.token = token;
    apiServer.defaults.headers.appVersion = appVersion;
    return new Promise((resolve, reject) => {
      apiServer.post('requestDataService.ashx', postData)
        .then((res) => {
          if (res.data && res.data.rs === 'OK') {
            const buff = Buffer.from(res.data.data, 'base64');
            const response = JSON.parse(buff.toString());
            resolve(response);
          } else {
            reject();
          }
        })
        .catch((error) => {
          console.log('error', error);
          reject();
        });
    });
  },
  doTapPayByPrime: (token, data) => {
    apiServer.defaults.headers.token = token;
    return new Promise((resolve, reject) => {
      apiServer.post('tapPayService.ashx', data)
        .then((res) => {
          // console.log('dotappay res', res);
          if (res.data && res.data.rs === 'OK') {
            // const buff = Buffer.from(res.data.data, 'base64');
            // const response = JSON.parse(buff.toString());
            // resolve(response);
            resolve(res);
          } else {
            reject(res);
          }
        })
        .catch((error) => {
          console.log('error', error);
          reject(error);
        });
    });
  },
  codeVerification: (token, data) => {
    const { type, code } = data;
    let request = '';
    let requestData = {};
    switch (type) {
      case 'invoiceCarrierCode':
        request = 'phoneBarCodeVerification';
        requestData = { cellPhone: code };
        break;
      case 'invoiceDonateCode':
        request = 'donateNPOVerification';
        requestData = { pCode: code };
        break;
      default:
        break;
    }
    const postData = {
      request,
      requestDataString: Buffer.from(JSON.stringify(requestData)).toString('base64'),
      apiToken: '',
      apiTokenObject: '',
    };
    apiServer.defaults.headers.token = token;
    return new Promise((resolve, reject) => {
      apiServer.post('requestDataService.ashx', postData).then((res) => {
        if (res.data && res.data.rs === 'OK') {
          const buff = Buffer.from(res.data.data, 'base64');
          const response = JSON.parse(buff.toString());
          resolve(response);
        } else {
          resolve(null);
        }
      })
        .catch((error) => {
          console.log('error', error);
          reject(error);
        });
    });
  },
};

// 模組測試
if (require.main === module) {
  (async () => {
    const no = 'A08P70637';
    const mainProfile = await exports.getProfile(no);
    const subStoreIds = await exports.getSubStoreNo(mainProfile.token, no);
    const subProfile = await exports.getProfile(subStoreIds[0].contractNo);
    console.log('subStoreIds', subProfile);
  })();
}
